import { StateSchema } from "@/app/providers/StoreProvider";

export const getPersonalityListIsLoading = (state: StateSchema) => state.personality?.listIsLoading;
export const getPersonalityListError = (state: StateSchema) => state.personality?.listError;
export const getPersonalityListData = (state: StateSchema) => state.personality?.listData || [];
